import { PUBLISHED_STATUS } from '../model/FestivalData';

interface VersionStatus {
  version: number;
  status: PUBLISHED_STATUS;
}

/** The version the apps show: the highest-numbered published one, or null when none is published */
export const liveVersion = (versions: VersionStatus[]): number | null =>
  versions.reduce<number | null>(
    (live, { version, status }) => (status === 'published' && (live === null || version > live) ? version : live),
    null,
  );

/** Which version the apps show now, and which they will show once a version's status changes */
export const liveVersionChange = (versions: VersionStatus[], version: number, status: PUBLISHED_STATUS) => {
  const others = versions.filter(other => other.version !== version);
  return {
    before: liveVersion(versions),
    after: liveVersion([...others, { version, status }]),
  };
};
